import api from './api';
import { extractOriginalFrameUrl } from '../utils/cameraPreview';

const normalizeCameraList = (responseData) => {
  if (Array.isArray(responseData)) return responseData;
  if (Array.isArray(responseData.results)) return responseData.results;
  console.warn("Unknown camera API format:", responseData);
  return [];
};

const sortCameras = (data) =>
  [...data].sort((a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0));

export const listCameras = async (roomId, params = {}) => {
  if (Array.isArray(params.camera_type)) {
    const { camera_type: cameraTypes, ...restParams } = params;
    const responses = await Promise.all(
      cameraTypes.map((cameraType) =>
        api.get(`/rooms/${roomId}/cameras`, {
          params: { ...restParams, camera_type: cameraType },
        })
      )
    );

    const merged = responses.flatMap((response) => normalizeCameraList(response.data));
    const unique = Array.from(new Map(merged.map((camera) => [camera.id, camera])).values());
    return sortCameras(unique);
  }

  return api.get(`/rooms/${roomId}/cameras`, { params })
    .then((response) => sortCameras(normalizeCameraList(response.data)));
};


export const getCamera = (id) =>
    api.get(`/cameras/${id}`)
       .then(r => r.data);
// // Получение одной камеры по room_id и camera_id
// export const getCamera = async (roomId, cameraId) => {
//     try {
//         // Получаем все камеры в комнате
//         const response = await api.get(`/rooms/${roomId}/cameras`);
//         let cameras = [];
        
//         if (Array.isArray(response.data)) {
//             cameras = response.data;
//         } else if (Array.isArray(response.data.results)) {
//             cameras = response.data.results;
//         } else {
//             console.warn("Unknown camera API format:", response.data);
//             return null;
//         }
        
//         // Ищем нужную камеру по ID
//         const camera = cameras.find(cam => cam.id === parseInt(cameraId));
        
//         if (!camera) {
//             throw new Error(`Camera with ID ${cameraId} not found in room ${roomId}`);
//         }
        
//         return camera;
//     } catch (error) {
//         console.error('Error getting camera:', error);
//         throw error;
//     }
// };

export const createCamera = (id, payload) =>
    api.post(`/rooms/${id}/cameras`, payload)
       .then(r => r.data);

export const updateCamera = (id, payload) =>
    api.patch(`/cameras/${id}`, payload)
       .then(r => r.data);

export const deleteCamera = (id) =>
    api.delete(`/cameras/${id}`)
       .then(r => r.data);

export const cancelDeleteCamera = (id) =>
    api.post(`/cameras/${id}/cancel-delete`)
       .then(r => r.data);

export const getLastFrame = (id) =>
    api.get(`/cameras/${id}/frames?limit=1&offset=0`)
       .then(r => {
           if (Array.isArray(r.data)) return r.data;
           if (Array.isArray(r.data.results)) return r.data.results;
           if (r.data && Array.isArray(r.data.items)) return r.data.items;
           console.warn("Unknown frames API format:", r.data);
           return [];
       });
       
/**
 * B1 / FE-Z01: кадр для рисования зон в каноническом (original) пространстве.
 * Основной источник — `GET /cameras/{id}.original` (reference-кадр камеры,
 * full-res); в списке кадров backend отдаёт original: null, а processed
 * уменьшен scale_factor'ом и для координат зон не годится. Резолвит
 * `{ url, source }` или null, если original-кадра нет. Ошибки запроса
 * пробрасываются: UI обязан отличать «сеть упала» от «кадров нет».
 */
export const getCameraPreviewFrame = (id) =>
    getCamera(id).then((camera) => {
        const cameraUrl = camera?.original?.url;
        if (cameraUrl) return { url: cameraUrl, source: 'camera' };
        return getLastFrame(id).then((frames) => {
            const frameUrl = extractOriginalFrameUrl(frames);
            return frameUrl ? { url: frameUrl, source: 'frame' } : null;
        });
    });

export const startCamera = (id) =>
    api.post(`/cameras/${id}/start`)
       .then(r => r.data);

export const stopCamera = (id) =>
    api.post(`/cameras/${id}/stop`)
       .then(r => r.data);

export const restartCamera = (id) =>
    api.post(`/cameras/${id}/restart`)
       .then(r => r.data);

export const getCameraConnection = (id) =>
    api.get(`/cameras/${id}/connection`)
       .then(r => r.data);

export const listCameraEvents = (id, { event_code, limit = 50, offset = 0 } = {}) =>
    api.get(`/cameras/${id}/events`, { params: { event_code, limit, offset } })
       .then(r => r.data);
